module.exports = __webpack_public_path__ + "f48b74dc62cf6604d44dd2c23780baa4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/clowns-cabin-main.png
// module id = 567
// module chunks = 0